export default function AccidentalDamageGrid() {
  const protectionItems = [
    {
      title: "Covered for Spills & Stains",
      description: "Accidental coffee, food, or liquid stains won't ruin your furniture.",
      image: "/nestroot/spills-stains.png"
    },
    {
      title: "Protected from Pet Damage",
      description: "Accidental pet-related damage that impacts functionality or structure is covered.",
      image: "/nestroot/pet-damage.png"
    },
    {
      title: "Safe from Impacts & Accidents",
      description: "Cracks or accidental hits during daily use are protected.",
      image: "/nestroot/impacts-accidents.png"
    },
    {
      title: "Covered for Rips & Tears",
      description: "Protection against accidental rips or tears impacting functionality.",
      image: "/nestroot/rips-tears.png"
    }
  ];

  return (
    <section className="tw-py-20 tw-bg-[#F8F9FA]">
      <div className="tw-max-w-7xl tw-mx-auto tw-px-6 lg:tw-px-8">
        <h2 
          className="tw-text-4xl md:tw-text-5xl tw-font-medium tw-text-center tw-text-black tw-mb-16 tw-px-6 sm:tw-px-8"
          style={{ fontFamily: "'Instrument Serif', serif" }}
        >
          Accidental Damage Protection
        </h2>

        <div className="tw-flex lg:tw-grid tw-overflow-x-auto lg:tw-overflow-visible tw-snap-x tw-snap-mandatory lg:tw-snap-none tw-gap-10 md:tw-gap-12 tw-pb-8 lg:tw-pb-0 no-scrollbar lg:tw-grid-cols-4 tw-px-8 lg:tw-px-0">


          {protectionItems.map((item, index) => (
            <div 
              key={index} 
              className="tw-group tw-flex tw-flex-col tw-items-center tw-text-center tw-min-w-[280px] sm:tw-min-w-[340px] lg:tw-min-w-0 tw-snap-center lg:tw-cursor-pointer"
            >
              <div className="tw-transition-transform tw-duration-500 tw-ease-in-out lg:group-hover:tw-scale-105">

                {/* Image Container */}
                <div className="tw-w-full tw-aspect-square tw-mb-6 tw-overflow-hidden tw-rounded-2xl tw-bg-white tw-shadow-sm group-hover:tw-shadow-md lg:group-hover:tw-shadow-sm tw-transition-shadow tw-duration-500">
                  <img 
                    src={item.image} 
                    alt={item.title} 
                    className="tw-w-full tw-h-full tw-object-cover"
                  />
                </div>

                {/* Text Content */}
                <h3 
                  className="tw-text-xl md:tw-text-2xl tw-font-semibold tw-text-black tw-mb-3"
                  style={{ fontFamily: "'Outfit', sans-serif" }}
                >
                  {item.title}
                </h3>
                <p 
                  className="tw-text-gray-600 tw-text-base md:tw-text-lg tw-leading-relaxed tw-max-w-[280px] tw-mx-auto"
                  style={{ fontFamily: "'Outfit', sans-serif" }}
                >
                  {item.description}
                </p>
              </div>
            </div>
          ))}
        </div>


      </div>
    </section>
  );
}
